import React from 'react';
import { Svg } from '@chat/components';
import { IM_MESSAGE } from '@/typings/global';
import { GM_AVATAR, GM_NICK } from '@/helpers/userInfo';

function Loading({ type, message }: IM_MESSAGE): JSX.Element {
    return (
        <li className="im-message-in">
            {GM_AVATAR('faq', 'faq')}
            <div className="im-message-block">
                {GM_NICK('faq', 'faq')}
                <div className="im-message-content">
                    <Svg.LoadingDots />
                </div>
            </div>
        </li>
    );
}

export default Loading;
